/** @format */

import {Box} from '@mui/material';

import {CalcMethod} from '../../model';
import {WidgetMethodRoot as Root, methodClasses as classes} from './style';
import {SplitButtons} from '../SplitButtons';

interface Props {
  color: string;
  calcMethod?: CalcMethod;
  onClick: (newMethod: CalcMethod) => void;
  disabled?: boolean;
}

const WidgetMethodButton = ({color, calcMethod, onClick, disabled}: Props) => {
  const graphIcon = new URL('./images/graph.svg', import.meta.url).href;

  return (
    <Root color={color}>
      <Box className={classes.border} />
      <Box className={classes.content}>
        <Box className={classes.icon}>
          <img src={graphIcon} alt='Graph' />
        </Box>
        <SplitButtons<CalcMethod>
          options={[
            {
              id: 'sum',
              content: 'Сумма',
              onClick: () => onClick('sum'),
            },
            {
              id: 'day',
              content: 'День',
              onClick: () => onClick('day'),
            },
          ]}
          color={color}
          currentValue={calcMethod}
          disabled={disabled}
        />
      </Box>
    </Root>
  );
};

export {WidgetMethodButton};
